const Constants = {
    MAP_CHANGE : 'MAP_CHANGE',
    UPDATE_ZOOM : 'UPDATE_ZOOM',
    UPDATE_SEARCH: 'UPDATE_SEARCH',
    SHOW_DETAILS: 'SHOW_DETAILS',
    HIDE_DETAILS: 'HIDE_DETAILS',
    SET_VILLA_DATA: 'SET_VILLA_DATA',
    IS_CHANGING: 'IS_CHANGING',
    SET_CURRENT_MARKER: 'SET_CURRENT_MARKER',
}

export default Constants
